// Strings for the signer flow. English only at launch (spec § Decisions); keys are flat "group.key" with
// {placeholders} and .one/.other plurals, mirroring locales/booking so a translation loader can be added later.
import en from '~/locales/esign/en.json'

export type EsignTextKey = keyof typeof en
export type EsignParams = Record<string, string | number>

export function formatEsignMessage(template: string, params: EsignParams = {}): string {
  return template.replace(/\{(\w+)\}/g, (match, name: string) => (name in params ? String(params[name]) : match))
}

export function createEsignT(messages: Readonly<Record<string, string>> = en) {
  const lookup = (key: string) => messages[key] ?? (en as Record<string, string>)[key] ?? key
  const t = (key: EsignTextKey, params?: EsignParams): string => formatEsignMessage(lookup(key), params)
  const tc = (base: string, count: number, params?: EsignParams): string =>
    formatEsignMessage(lookup(`${base}.${count === 1 ? 'one' : 'other'}`), { count, ...params })
  return { t, tc }
}

export function useEsignT() {
  return createEsignT()
}
